import { AppConfig } from '@app/config'
import { AuthService } from "../services/auth.service";
import { ApiViewData } from "../app/app.interfaces";


export function RestangularConfigFactory (RestangularProvider, authService: AuthService) {
    
  RestangularProvider.setBaseUrl(AppConfig.apiBaseUrl);    
  RestangularProvider.setPlainByDefault(true);
  
  // RestangularProvider.setRestangularFields({
  //   id: "@id"
  // });
  
  // Hydra collections support
  RestangularProvider.addResponseInterceptor(basicHydraResponseInterceptor);
    
  //Set token for every request
  RestangularProvider.addFullRequestInterceptor((element, operation, path, url, headers, params) => {
    return {
      headers: Object.assign({}, headers, {Authorization: `Bearer ${authService.token}`})
    };
  });
  
  RestangularProvider.addErrorInterceptor((response, subject, responseHandler) => {
        
    switch(response.status){
      
      case 401:
        
        authService.renewToken().then(() => {          
          response.request.headers.set('Authorization', `Bearer ${authService.token}`); 
          return response.repeatRequest(response.request).subscribe(res => {
            responseHandler(res);
          }, err => {
            subject.error(err);
          });          
        }, (err) => {
            subject.error(err);
        });
        
        //Error handled:
        return false;
        
      default:
        console.log('Unhandled error response:', response);
        //Todo show error message somehow
        break;
    }
    
    //Error not handled:
    return true; 
  });
}

const basicHydraResponseInterceptor = function(data, operation){
  
  if(operation==='remove' && data === null){
    return true;
  }
  
  let extractedData: any = {};
  // .. to look for getList operations
  if (operation === 'getList' && data['hydra:member']) {
      // .. and handle the data and meta data
      extractedData = data['hydra:member'];
      // extractedData.view = data['hydra:view'];
      
      let viewData: ApiViewData = {}; 
      if( data['hydra:totalItems']) {
        viewData.totalItems = data['hydra:totalItems'];
      }
      
      if(typeof data['hydra:view'] !== 'undefined') {
        viewData.pages = {
            current: data['hydra:view']['@id'] || null,
            next: data['hydra:view']['hydra:next'] || null,
            previous: data['hydra:view']['hydra:previous'] || null,
            last: data['hydra:view']['hydra:last'] || null,          
        }
      }
      else {
        viewData.pages = {
          current: '1',
          next: null, 
          previous: null, 
          last: '1'
        }
      }      
      extractedData.view = viewData;
  } 
  else {
      extractedData = data;
  }
  return extractedData;
};
 
// const advancedHydraResponseInterceptor = function(data, operation) {
//  
//   // Remove trailing slash to make Restangular working
//   function populateHref(data) {
//       if (data["@id"])  data.href = data["@id"].substring(1);
//   }
//   // Adding the missing ID property objects
//   function populateCleanId(data) {
//       if (data["@id"])  data.id = parseInt(data["@id"].split("/").pop(),10);
//   }
//
//   function populateChildren(data)
//   {
//     for (const value of Object.values(data)) {
//       if(typeof value === 'object') hydrate(value);
//     }
//   }
//
//   function hydrate(data)
//   {
//       populateHref(data);
//       populateCleanId(data);
//       populateChildren(data);
//   }
//
//   // Populate href and id property for the collection
//   hydrate(data);
//  
//   if ("getList" === operation) {
//       let collectionResponse = data["hydra:member"];
//       collectionResponse.metadata = {};
//
//       // Put metadata in a property of the collection
//       for (const [key, value] of Object.entries(data)) {
//         if ("hydra:member" !== key) {
//           collectionResponse.metadata[key] = value;
//         }
//       }        
//
//       for (const value of Object.values(collectionResponse)) {
//           hydrate(value);
//       }
//        
//       return collectionResponse;
//   }
//
//   return data;
// };


// WEBPACK FOOTER //
// ./src/helpers/restangular.config.factory.ts